module.exports = __webpack_public_path__ + "muktijuddho-b5fc6e0cb6f1002b1a41.svg";